var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.vehicule)?_c('vehicule-form',{attrs:{"type-ajout":"reprise","disabled-fields":_vm.disabledFields,"initial-vehicule":_vm.vehicule},on:{"created":_vm.vehiculeCreated}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }